<template>
  <v-btn 
    color="success"
    @click="clickHandler">
    Test Button
  </v-btn>

</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'TestButton',
  data () {
    return {}
  },
  
  computed: {
  },

  methods : {
    ...mapMutations(['']),
    clickHandler : function () {
      console.log("Clicked")
    }
  },
}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TestButton.vue